/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCheckPaymentByProviderModel,
  ICheckPaymentByProviderRequest,
  IMappers,
  ICheckPaymentByProviderResponse,
  ICheckPaymentByProviderResponseError,
  TCheckPaymentByProviderResponse,
} from './types';

const defaultConfig: TCheckPaymentByProviderModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'billing-payments',
  pathApi: '/v1/check-payment-by-provider/',
  hostType: 'api',
} as TCheckPaymentByProviderModel;

function createCheckPaymentByProviderModel(parameters: ICheckPaymentByProviderRequest): TCheckPaymentByProviderModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckPaymentByProviderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckPaymentByProviderRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckPaymentByProvider<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICheckPaymentByProviderOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCheckPaymentByProviderResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCheckPaymentByProviderModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckPaymentByProviderResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckPaymentByProviderResponseError);
    }
  }

  return { response, statusCode } as TCheckPaymentByProviderResponse;
}

export { defaultConfig, createCheckPaymentByProviderModel, fetchCheckPaymentByProvider };
